import axios from 'axios'
import endpoints from '../../endpoints'

const API_URL = process.env.REACT_APP_API_URL

export async function fetchStaffList() {
  try {
    const response = await axios.get(API_URL + endpoints.staff.list)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function createStaff(body) {
  try {
    const response = await axios.post(API_URL + endpoints.staff.create, body)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function updateStaff(body) {
  try {
    const response = await axios.post(API_URL + endpoints.staff.update, body)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function deleteStaff(StaffId) {
  try {
    const response = await axios.delete(API_URL + endpoints.staff.delete + StaffId)
    return response.data
  } catch (error) {
    throw error
  }
}

export async function addNFCtoStaff(payload) {
  try {
    const response = await axios.put(API_URL + endpoints.nfc.createUserNFC, payload)
    return response.data
  } catch (error) {
    throw error
  }
}
export async function getStaffNFC(staffId) {
  try {
    const response = await axios.put(API_URL + endpoints.nfc.getUserNFC, {
      id: staffId,
      type: 'staff',
    })
    return response.data
  } catch (error) {
    throw error
  }
}
